import React, { useEffect, useState } from "react";
import FooterSection from "../../components/pages/home/footer-section";
import IntroductionSection from "../../components/pages/home/introduction-section";
import NavbarSection from "../../components/pages/home/navbar-section";
import ProjectListSection from "../../components/pages/home/project-list-section";
import PageMeta from "../../components/common/page-meta";
import { HomeContainer } from "./style";

const Home = () => {
  const [scrollBar, setScrollBar] = useState(0);

  useEffect(() => {
    window.onscroll = () => {
      const bodyScrollTop = document.body.scrollTop;
      const { scrollTop, scrollHeight, clientHeight } =
        document.documentElement;
      const percentage =
        ((scrollTop + bodyScrollTop) / (scrollHeight - clientHeight)) * 100;
      setScrollBar(percentage);
    };
  }, []);

  return (
    <>
      <PageMeta
        title="Freddy's — Design, product, and notes"
        description="The portfolio, independent projects, and writing of Freddy Albert Sanjaya."
      />
      <NavbarSection percentage={scrollBar} showLine={false} />
      <HomeContainer>
        <IntroductionSection>
          <ProjectListSection />
        </IntroductionSection>
      </HomeContainer>
      <FooterSection />
    </>
  );
};

export default Home;
